var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.332 18C7.79603 18 4.33303 13.74 4.33303 12C4.33303 9.999 7.79203 6 12.333 6C16.709 6 20.331 9.973 20.331 12C20.331 13.74 16.869 18 12.333 18H12.332ZM12.333 4C6.81203 4 2.33203 8.841 2.33203 12C2.33203 15.086 6.90803 20 12.332 20C17.755 20 22.332 15.086 22.332 12C22.332 8.841 17.852 4 12.332 4",
    fill: "#1D3F66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.309 13.984C11.206 13.984 10.309 13.087 10.309 11.984C10.309 10.881 11.206 9.984 12.309 9.984C13.413 9.984 14.309 10.881 14.309 11.984C14.309 13.087 13.413 13.984 12.309 13.984ZM12.309 7.984C10.103 7.984 8.30903 9.778 8.30903 11.984C8.30903 14.19 10.103 15.984 12.309 15.984C14.516 15.984 16.309 14.19 16.309 11.984C16.309 9.778 14.516 7.984 12.309 7.984Z",
    fill: "#1D3F66"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.06ce3d9a349bef299c55b73553542659.svg";
export { ForwardRef as ReactComponent };